import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export function useUnread() {
  const [count, setCount] = useState(0);
  const refresh = () => api.get("/orders/unread").then((r) => setCount(r.data.count)).catch(() => {});
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 5000);
    return () => clearInterval(t);
  }, []);
  return [count, refresh];
}

export function PortalShell({ title, tabs, active, setActive, unread, children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isAdmin = !user || user?.role === "admin";
  return (
    <div className="min-h-screen" data-testid="portal-shell">
      <header className="border-b border-[#D4AF37]/15 bg-[#0B0907]/90 backdrop-blur-xl sticky top-0 z-40">
        <div className="mx-auto max-w-7xl px-5 py-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0">
            <Link to="/" className="font-display tracking-[0.3em] text-sm text-[#F3E5AB] shrink-0">ANCIENT ORIGIN</Link>
            <span className="hidden sm:inline font-serif-it text-[#A89F91] truncate">{title}</span>
            {isAdmin && (
              <Link to={title === "Admin portal" ? "/manufacturer" : "/admin"} className="rounded-full border border-[#D4AF37]/40 px-3 py-1 text-[10px] uppercase tracking-[0.15em] text-[#F3E5AB] hover:bg-[#D4AF37] hover:text-[#0B0907]" data-testid="portal-switch-button">
                {title === "Admin portal" ? "Manufacturer view" : "Admin view"}
              </Link>
            )}
          </div>
          <div className="flex items-center gap-4">
            <button onClick={() => setActive("orders")} className="relative text-[#F3E5AB]" data-testid="notification-bell" aria-label="Order updates">
              <Bell className="h-5 w-5" strokeWidth={1.4} />
              {unread > 0 && <span className="absolute -top-2 -right-2 h-4 min-w-4 px-1 rounded-full bg-[#8B1E1E] text-[10px] text-white grid place-items-center" data-testid="notification-count">{unread}</span>}
            </button>
            <span className="hidden md:inline text-xs text-[#A89F91]">{user ? user.name : "Admin"}</span>
            {user && <button onClick={() => { logout(); nav("/login"); }} className="text-[#A89F91] hover:text-[#E06D3B]" data-testid="logout-button" aria-label="Log out"><LogOut className="h-4 w-4" /></button>}
          </div>
        </div>
        <nav className="mx-auto max-w-7xl px-5 flex gap-1 overflow-x-auto scrollbar-thin">
          {tabs.map((t) => (
            <button key={t.k} onClick={() => setActive(t.k)} className={`shrink-0 px-4 py-3 text-xs uppercase tracking-[0.18em] border-b-2 transition-colors ${active === t.k ? "border-[#D4AF37] text-[#F3E5AB]" : "border-transparent text-[#6E6558] hover:text-[#A89F91]"}`} data-testid={`portal-tab-${t.k}`}>
              {t.l}{t.badge ? <span className="ml-2 rounded-full bg-[#8B1E1E] px-1.5 text-[10px] text-white">{t.badge}</span> : null}
            </button>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-8">{children}</main>
    </div>
  );
}
